import * as Yup from 'yup';

export const PublicBookingSchema = Yup.object().shape({
    bookingFor: Yup.string().required('Booking field is required').oneOf(['myself', 'others'], 'Please select a valid option'),
    relationshipWithThePatient: Yup.string().when('bookingFor', {
        is: 'others',
        then: Yup.string().required('Relationship field is required'),
    }),
    service_id: Yup.number().required('Service field is required'),
    date: Yup.date().required('Date field is required'),
    time: Yup.number().required('Time slot field is required'),
    informant_name: Yup.string().when('bookingFor', {
        is: 'others',
        then: Yup.string().required('Informant name field is required'),
    }),
    concerns: Yup.string().trim().required('The concerns field is required').max(500, 'The concerns field must be less than 500 characters'),
    referral_letter: Yup.object().when('service_id', {
        is: (value) => {
            if (value === 4 || value === 9) {
                return true
            } else {
                return false
            }
        },
        then: Yup.object().required("The referral field is required")
    })
})

export const AppBookingSchema = Yup.object().shape({
    service_id: Yup.number().required('Service field is required'),
    date: Yup.date().required('Date field is required'),
    schedule_id: Yup.number().required('Time slot field is required'),
    concerns: Yup.string().trim().required('The concerns field is required'),
})